// extracted by mini-css-extract-plugin
module.exports = {"addWorkerModal":"AddWorkerModal_addWorkerModal__3VmoK"};